<template>
    <div class="update-info">
        <van-nav-bar title="设置" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <div class="view">
            <!-- <van-image width="60" height="60" fit="contain" :src="photoAddr" />
            <p class="card text-ellipsis">学生卡：{{userData.imei}}</p>
            <input class="name-input" v-model="userData.name" @blur="resetName" />
            <van-button class="save-btn" type="info" @click="clickSave">保存</van-button> -->
            <van-cell @click="isshow(1)" class="cell df-al-c" title="设置手机号" title-class="cell-title" :border="false" :is-link="true" :clickable="true">
                <span style="margin-right:10px;">{{!userData.simPhone || userData.simPhone ==''?'未设置':userData.simPhone}}</span>
                <i slot="right-icon" class="right-icon iconfont iconback_grey"></i>
            </van-cell>
            <van-cell @click="isshow(2)" class="cell df-al-c" title="宝贝姓名" title-class="cell-title" :border="false" :is-link="true" :clickable="true">
                <span style="margin-right:10px;">{{!userData.name || userData.name==''?'未设置':userData.name}}</span>
                <i slot="right-icon" class="right-icon iconfont iconback_grey"></i>
            </van-cell>
            <van-dialog :beforeClose="closehd" style="width:70%" v-model="show" :title="types.title" show-cancel-button :closeOnClickOverlay="true">
                <van-field v-model="value" maxlength='15' input-align="left" :placeholder="types.placeTest" />
            </van-dialog>
        </div>
    </div>
</template>

<script>
import { isEmpty } from '@/utils/lib/common';
export default {
    data() {
        return {
            show: false,//弹窗
            value: '',//输入内容
            types: {//传递给弹窗数据
                title: '',
                placeTest: ''
            },
            isNum: '',//方便做输入判断
            userData: JSON.parse(this.$route.query.data),
            photoAddr: require('@/assets/images/more/header.png'),
        };
    },
    created() {
    },
    methods: {
        /**
         * 返回上一页
         */
        backPage() {
            this.$router.back(-1);
        },
        /**
         * 弹出弹框
         * @param types 唤起弹窗类型
         */
        isshow(types) {
            this.show = true;
            if (types == 1) {
                this.types = {
                    title: '设置手机号',
                    placeTest: '请输入设备手机号'
                }
                this.isNum = 1;
                this.value = this.userData.simPhone
            } else {
                this.types = {
                    title: '宝贝姓名',
                    placeTest: '请输入宝贝姓名'
                }
                this.isNum = 2;
                this.value = this.userData.name
            }
        },
        /**
         * 弹窗关闭前
         */
        closehd(action, done) {
            let that = this;
            let param = '';
            if (action === 'confirm') {
                if (this.isNum == 1 && isEmpty(this.value)) {
                    this.$toast({
                        message: "手机号码不能为空！",
                        duration: "1000"
                    })
                    done(false);
                    return
                }

                if (this.isNum == 1 && !/^1[3456789]\d{9}$/.test(this.value)) {
                    this.$toast({
                        message: "手机号码格式错误！",
                        duration: "1000"
                    })
                    done(false);
                    return
                }
                if (this.isNum == 2 && isEmpty(this.value)) {
                    this.$toast({
                        message: "姓名输入不能为空！",
                        duration: "1000"
                    })
                    done(false);
                    return
                }
                // if (this.isNum == 2 && !/^[a-zA-Z0-9\u4e00-\u9fa5]+$/gi.test(this.value)) {
                if (this.isNum == 2 && /[`~!@#$%^&*￥()_+<>?:"{},.\/;'[\]]/im.test(this.value)) {
                    this.$toast({
                        message: "不允许输入特殊符号",
                        duration: "1000"
                    })
                    done(false);
                    return
                }
                if (this.isNum == 1) {
                    param = {
                        simPhone: this.value
                    }
                } else if (this.isNum == 2) {
                    param = {
                        name: this.value
                    }
                }
                this.$http.post(this.$api.babyCard.UPTADE_BABYCARD, param).then(res => {
                    if (res.code === 0) {
                        this.$store.commit('set_userinfo', JSON.stringify(res.data));
                        // this.$toast({
                        //     message: '修改成功',
                        //     duration: 1000,
                        //     icon: require('@/assets/images/safety-fence/correct.png')
                        // });
                        this.value = ''
                        this.getStudent();
                    } else {
                        that.$toast({
                            message: res.msg,
                            duration: 2000,
                            icon: require('@/assets/images/safety-fence/wrong.png'),
                        });
                        this.value = ''
                    }
                });
                done()

            } else if (action === 'cancel') {
                this.value = ""
                done() //关闭
            }

        },
        /**
        * 获取学员基本信息
        */
        getStudent() {
            this.$http.get(this.$api.babyCard.GET_BABYCARD, { showLoading: false }).then(res => {
                if (res.code === 0) {
                    this.userData = res.data;
                    this.$store.commit('set_userinfo', JSON.stringify(res.data));
                }
            });
        },
        /**
         * 确认接口
         */
        clickSave() {
            if (this.userData.name === " " || !this.userData.name) {
                this.$toast("请至少输入一个字符！")
                return
            }
            let postData = {
                name: this.userData.name
            }
            this.$http.post(this.$api.babyCard.UPTADE_BABYCARD, postData).then(res => {
                if (res.code === 0) {
                    this.$store.commit('set_userinfo', JSON.stringify(res.data));
                    this.$toast({
                        message: '修改成功',
                        duration: 1000,
                        icon: require('@/assets/images/safety-fence/correct.png')
                    });
                }
            });

        },
        /**
         * 字符判断
         */
        resetName() {
            let reg = /^([\u4E00-\u9FA5A-Za-z0-9])+$/;
            if (!reg.test(this.userData.name)) {
                Object.assign(this.$data, this.$options.data());
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.update-info {
    height: 100vh;
    background: rgb(242, 244, 248); // 单元格
    .view {
        // 右边icon
        .right-icon {
            font-size: 14px;
            color: #a0a1a7;
        }
        .cell{
            margin-top: 12px;
             height: 60px;
        }
    }
}
</style>

<style lang="scss">
.update-info {
    .van-field__body {
        .van-field__control {
            width: 99%;
            height: 31px;
            border: 1PX solid #ccc;
        }
    }
}
</style>
